export default "__VITE_ASSET__BQFnq6gH__"